import { render, staticRenderFns } from "./VesselAccessControlWrapper.vue?vue&type=template&id=a471fabe&scoped=true&"
import script from "./VesselAccessControlWrapper.vue?vue&type=script&lang=ts&"
export * from "./VesselAccessControlWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a471fabe",
  null
  
)

export default component.exports